<style lang="scss" scoped>
  .news-details{
    width:1000px;
    margin:0 auto;
    .title{
      font-size: 36px;
      text-align: center;
      font-weight: bold;
      margin-top: 30px;
    }
    .resource{
      text-align: center;
      color:#999;
      margin-top: 10px;
      span{
        margin:0 20px;
      }
    }
    .context{
      margin-top: 30px;
      font-size: 16px;
      line-height: 2;
      /deep/ p{
        text-indent: 2rem;
        font-size: 16px;
        margin-bottom: 20px;
        line-height: 2;
      }
      /deep/ img{
        width:80%;
        margin:0 auto 20px;
        display: block;
      }
     /deep/ .ql-align-left{
        text-align: left !important;
      }
     /deep/ .ql-align-right{
        text-align: right !important;
      }
     /deep/ .ql-align-center{
        text-align: center !important;
      }
    }
  }
  .el-breadcrumb{
    font-size: 16px!important;
  }
  @media screen and (max-width: 640px){
    .news-details{
      width: 100% !important;
      font-size: 12px!important;
      line-height: 20px;
    }
    .el-breadcrumb{
      font-size: 12px!important;
      margin-left: 10px;
    }
    section{
      padding-top: 20px!important;
    }
    .news-details .title {
      font-size: 16px!important;
    }
    .news-details .context {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
</style>
<template>
  <section class="wrap news-details">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{path: '/news'}">新闻资讯</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="title">{{details.name}}</div>
    <div class="resource"><span>时间：{{details.createTime | rTime}}</span></div>
    <div class="context" v-html="details.content">
    </div>
  </section>
</template>

<script>
import { newsDetails } from '@/services/api.index'
export default {
  inject: ['reload'],
  data () {
    return {
      details: {}
    }
  },
  created() {
    this.reload()
    this.getDetails()
  },
  methods: {
    getDetails () {
      const id = this.$route.params.id
      newsDetails(id).then(res => {
        res.data.content = res.data.content.replace(/<img/gi,'<img style="max-width:100%;margin:15px auto;display:block;"')
        this.details = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/details.vue